module.exports = __webpack_public_path__ + "img/passport.522a2345.png";